// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c7b8cee3","513":"0449507a","703":"09d2e066","787":"5a7290ea"}[chunkId] + ".chunk.js";
};